import { render, staticRenderFns } from "./inventarioporproveedor.vue?vue&type=template&id=205eff92"
import script from "./inventarioporproveedor.vue?vue&type=script&lang=js"
export * from "./inventarioporproveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports